import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaSnowflake,
  FaThermometerHalf,
  FaTools,
  FaCheckCircle,
  FaWhatsapp,
  FaCalendar,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const Hero = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    name: "ProCool AC Services",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Lahore",
      addressRegion: "Punjab",
      addressCountry: "PK",
    },
    telephone: "+92 305 4743725",
    email: "miansaif351@gmail.com",
    url: "https://procoolac.com",
    openingHours: "Mo-Sa 09:00-18:00",
    image: "https://procoolac.com/logo.png",
    priceRange: "$$",
    servesArea: {
      "@type": "Place",
      name: "Lahore",
    },
    hasOffer: {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "AC Repair",
      },
    },
    sameAs: [
      "https://www.facebook.com/your-page",
      "https://www.twitter.com/your-page",
    ],
  };

  return (
    <>
      <Helmet>
        <title>
          AC Service Lahore | Best AC Repair, Installation & Maintenance
        </title>
        <meta
          name="description"
          content="Professional AC Service in Lahore & Punjab. Expert AC repair, installation, maintenance, and gas refilling. 24/7 emergency service. ای سی سروس لاہور، بہترین ای سی مرمت، انسٹالیشن اور مینٹیننس۔"
        />
        <meta
          name="keywords"
          content="AC Service Lahore, AC Repair Lahore, AC Installation Lahore, AC Maintenance Lahore, ای سی سروس لاہور, Lahore HVAC"
        />
        <meta
          property="og:title"
          content="AC Service Lahore | Best AC Repair, Installation & Maintenance"
        />
        <meta
          property="og:description"
          content="Professional AC Service in Lahore & Punjab. Expert AC repair, installation, maintenance, and gas refilling. 24/7 emergency service."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://procoolac.com/" />
        <meta
          property="og:image"
          content="https://procoolac.com/og-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="AC Service Lahore | Best AC Repair, Installation & Maintenance"
        />
        <meta
          name="twitter:description"
          content="Professional AC Service in Lahore & Punjab. Expert AC repair, installation, maintenance, and gas refilling. 24/7 emergency service."
        />
        <meta
          name="twitter:image"
          content="https://procoolac.com/og-image.jpg"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <section
        className="gradient-bg text-white position-relative overflow-hidden"
        style={{
          minHeight: "100vh",
          paddingTop: "170px",
          background:
            "linear-gradient(135deg, #1e40af 0%, #0ea5e9 50%, #0284c7 100%)",
        }}
      >
        {/* Background Pattern */}
        <div
          className="position-absolute w-100 h-100"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.3,
          }}
        />

        <Container className="position-relative h-100 d-flex align-items-center">
          <Row className="align-items-center">
            <Col lg={6} className="fade-in">
              <div className="mb-4">
                <h1 className="display-4 fw-bold mb-3">
                  Professional AC Services for
                  <span className="d-block text-warning">
                    Commercial & Residential
                  </span>
                </h1>
                <p className="lead mb-4 fs-5">
                  Expert HVAC installation, repair, and maintenance services.
                  Keeping your property cool and comfortable year-round with
                  cutting-edge technology and certified technicians.
                </p>
              </div>

              <div className="d-flex flex-wrap gap-3 mb-4">
                <Button
                  variant="warning"
                  size="lg"
                  className="fw-semibold px-4 py-3"
                  style={{ borderRadius: "30px" }}
                >
                  <FaThermometerHalf className="me-2" />
                  Get Free Quote
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="fw-semibold px-4 py-3"
                  style={{ borderRadius: "30px" }}
                >
                  <FaTools className="me-2" />
                  Emergency Service
                </Button>
                <Button
                  variant="success"
                  size="lg"
                  className="fw-semibold px-4 py-3"
                  style={{ borderRadius: "30px" }}
                  href="https://wa.me/923054743725"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp className="me-2" />
                  WhatsApp
                </Button>
                <Button
                  as={Link}
                  to="/booking"
                  variant="info"
                  size="lg"
                  className="fw-semibold px-4 py-3"
                  style={{ borderRadius: "30px" }}
                >
                  <FaCalendar className="me-2" />
                  Book Appointment
                </Button>
              </div>

              <div className="row g-3">
                <div className="col-6 col-md-3">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-warning me-2" />
                    <span className="small">24/7 Service</span>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-warning me-2" />
                    <span className="small">Licensed & Insured</span>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-warning me-2" />
                    <span className="small">Same Day Service</span>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-warning me-2" />
                    <span className="small">Warranty Included</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6} className="slide-in-right">
              <div className="text-center">
                <div
                  className="bg-white bg-opacity-10 rounded-4 p-5 mx-auto"
                  style={{
                    maxWidth: "400px",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <FaSnowflake className="display-1 text-warning mb-4" />
                  <h3 className="fw-bold mb-3">Comprehensive HVAC Solutions</h3>
                  <div className="row g-3 text-start">
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <FaThermometerHalf className="text-warning me-2" />
                        <span>Installation</span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <FaTools className="text-warning me-2" />
                        <span>Repair</span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <FaSnowflake className="text-warning me-2" />
                        <span>Maintenance</span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <FaCheckCircle className="text-warning me-2" />
                        <span>Inspection</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Scroll Indicator */}
        <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4">
          <div className="text-center text-white-50">
            <div className="mb-2">Scroll to explore</div>
            <div className="animate-bounce">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M7 13l5 5 5-5" />
                <path d="M7 6l5 5 5-5" />
              </svg>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
